import { useTagStore } from "../stores/tag-store";

export const useTags = () => {
	const tags = useTagStore((state) => state.tags);
	const indexTags = useTagStore((state) => state.index);
	const searchTags = useTagStore((state) => state.search);
	const createTag = useTagStore((state) => state.create);
	const updateTag = useTagStore((state) => state.update);
	const deleteTag = useTagStore((state) => state.delete);
	const getTagsByIds = useTagStore((state) => state.getByIds);
	const mergeSelectedTags = useTagStore((state) => state.mergeSelectedTags);

	return { tags, indexTags, searchTags, createTag, updateTag, deleteTag, getTagsByIds, mergeSelectedTags };
};
